import { render, staticRenderFns } from "./KeuringrapportMatch.vue?vue&type=template&id=1115ae92"
import script from "./KeuringrapportMatch.vue?vue&type=script&lang=js"
export * from "./KeuringrapportMatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports